import React from 'react'

const Input = ({
  id,
  label,
  type,
  placeholder,
  value,
  onChange,
  required = false,
  error,
  className = '',
  ...rest
}) => {
  return (
    <div className='w-full flex flex-col items-start'>
      <label htmlFor={id} className='pb-1 text-sm lg:text-base'>{label}</label>
      <input
        required={required}
        onChange={onChange}
        value={value}
        className={`w-full outline-none rounded-xl px-7 py-3 border-2 ${error ? 'border-red-500' : 'border-accentYellow'} ${className}`}
        type={type}
        placeholder={placeholder}
        id={id}
        {...rest}
      />
      {error ? <p className='mt-1 text-xs text-red-500'>{error}</p> : null}
    </div>
  )
}

export default Input
